import { IdentifyOperation } from '@amplitude/analytics-types';
export var PROPERTY_ADD_OPERATIONS = [
    IdentifyOperation.SET,
    IdentifyOperation.SET_ONCE,
    IdentifyOperation.ADD,
    IdentifyOperation.APPEND,
    IdentifyOperation.PREPEND,
    IdentifyOperation.POSTINSERT,
];
//# sourceMappingURL=constants.js.map